import { Component, h, Host, JSX, Prop, State } from "@stencil/core";
import { RoutingKeys } from "@phn/entities/routing-key";
import {
  ClickElementTypes,
  EventActions,
  NavigationMode,
  NavigationModeType,
  NavigationTheme,
  NavigationThemeType,
} from "@phn/utility/constants";
import { navStateStore } from "@phn/state/nav-state-store";
import { GlobalDataLayerService } from "@phn/services/analytics/global-data-layer-service";
import { getRightTheme, IsLoggedIn } from "@phn/utility/helper";

@Component({
  tag: "phn-my-porsche-icon-button",
  styleUrl: "my-porsche-icon-button.scss",
  scoped: true,
})
export class MyPorscheIconButton {
  @Prop() mode: NavigationModeType = NavigationMode.navbar;

  @Prop() theme: NavigationThemeType = NavigationTheme.light;

  @State() isMyPorscheHoveredOn = false;

  private sendDataLayerEvent(): void {
    GlobalDataLayerService.getInstance().pushDataLayerEvent(
      EventActions.CONTEXTUAL_BUTTON_CLICK,
      {
        componentClick: {
          clickElementId: RoutingKeys.MY_PORSCHE,
          clickElementName: "open the my porsche menu",
          clickElementType: ClickElementTypes.Button,
        },
      },
    );
  }

  render(): JSX.Element {
    const { unreadMessagesCount, loggedInState } = navStateStore.state;
    const isLoggedIn = IsLoggedIn(loggedInState);

    return (
      <Host>
        <phn-p-button-pure
          icon={`user${isLoggedIn ? "-filled" : ""}`}
          hide-label="true"
          stretch="true"
          data-id={`${RoutingKeys.MY_PORSCHE}-contextual-button`}
          aria="{ 'aria-haspopup': 'dialog', 'aria-label' : 'open the my porsche menu' }"
          data-test-id="myporsche-button"
          theme={getRightTheme(this.theme, this.mode)}
          onMouseEnter={() => {
            this.isMyPorscheHoveredOn = true;
          }}
          onMouseLeave={() => {
            this.isMyPorscheHoveredOn = false;
          }}
          onClick={() => {
            this.sendDataLayerEvent();
          }}
        />

        {unreadMessagesCount > 0 ? (
          <span
            class={`myporsche-unread-messages-indicator ${getRightTheme(this.theme, this.mode)}`}
          />
        ) : null}
      </Host>
    );
  }
}
